<div class="course-list-container">

  <!-- Header Section -->
  <div class="content-section">
    <div class="title">What you will learn</div>
    <div class="sub-title">An overview of all your courses!</div>
  </div>

  <!-- Search Bar Section -->
  <div class="search-bar">
    <input type="text" [ngModel]="searchText" (ngModelChange)="onSearch($event)" placeholder="Find your course" />
    <i class="fa-solid fa-magnifying-glass"></i>
  </div>

  <!-- Category Button Section -->
  <div class="category-section">
    <div *ngFor="let category of categories" class="topic" (click)="onSelectTopic(category)"
      [ngClass]="{ 'active-topic': selectedTopic == category }">
      {{ category }}
    </div>
  </div>

  <!-- List of courses space -->
  <div class="topic-section" *ngIf="!isLoading">
    <div class="topics" *ngIf="selectedTopic == 'all'">
      <ng-container *ngFor="let category of categories">
        <app-category *ngIf="courses[category]" [category]="category" [courseList]="courses[category]"></app-category>
      </ng-container>
    </div>
    <app-category *ngIf="selectedTopic !== 'all'" [courseList]="courses[selectedTopic]"
      [category]="selectedTopic"></app-category>
  </div>
  <div class="spinner-icon" *ngIf="isLoading">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <label for="">Loading</label>
  </div>
</div>